import React, { useEffect } from 'react';

import { WistaVideo } from 'components/Video';
import { BootcampV3ActiveCampaignForm } from 'components/ActiveCampaign';
import { Countdown } from 'components/Countdown';

import * as DATA from './data';

import styles from './styles.module.scss';

function Form({ dateDiff }) {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'activeCampaignFormScript.js';
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapper__form}>
        <Countdown dateDiff={dateDiff} />
        <p className={styles.description}>
          Enter your email to pre-register for the
          Blockchain Bootcamp V3
        </p>
        <BootcampV3ActiveCampaignForm />
      </div>
      <div className={styles.wrapper__video}>
        <WistaVideo video={DATA?.VIDEO} />
      </div>
    </div>
  );
}

export default Form;
